// useTags.ts
import { ref } from 'vue';
import axios from 'axios';
import { Toaster } from '@/components/ui/sonner'
import { toast } from 'vue-sonner'
interface UseTagsOptions {
	initialTags: string[];  // Explicitly type as string array
	mediaItem: {
		id: string;
	};
}

export function useTags(options: UseTagsOptions) {
	const tagList = ref<string[]>(options.initialTags);

	const updateTags = async () => {
		try {
			const response = await axios.post('/services/json', {
				method: 'media.updateFile',
				id: options.mediaItem.id,
				newProperties: {
					tags: tagList.value.join(' ')
				}
			});

			if (!response.data.status) {
				toast({
					title: 'Error',
					description: response.data.result,
					variant: 'destructive'
				});
			} else {
				toast('Success', {
					description: "Tags Updated"
				})
			}
			return response.data.status;
		} catch (error) {
			toast({
				title: 'Error',
				description: error instanceof Error ? error.message : 'Unknown error',
				variant: 'destructive'
			});
			return false;
		}
	};

	return {
		tagList,
		updateTags
	};
}
